import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  BusquedaPorUsuarioResponse,
  BusquedaPorWalletResponse,
} from '../interfaces/wallet-lookup.interface';

/**
 * Service del "Responsable por Wallet" (consulta de operador, solo lectura).
 *
 * Apunta a `wallet-lookup` en el backend NestJS. Va por `HttpClient` plano, así
 * que el `ApiRestInterceptor` adjunta el idToken de Cognito automáticamente. El
 * backend exige el grupo `aguacate_operator`.
 *
 * No consulta Binance ni Chainalysis: todo sale de base. El riesgo de una
 * dirección lo sigue respondiendo la pantalla "Validar Wallet".
 */
@Injectable({ providedIn: 'root' })
export class WalletLookupService {
  private baseUrl = `${environment.apiNest}wallet-lookup`;

  constructor(private http: HttpClient) {}

  /** Dirección wallet→usuarios: quién tiene asignada esta dirección. */
  buscarPorWallet(address: string): Promise<BusquedaPorWalletResponse> {
    return firstValueFrom(
      this.http.get<BusquedaPorWalletResponse>(`${this.baseUrl}/by-address`, {
        params: { address },
      }),
    );
  }

  /** Dirección usuario→wallets: qué direcciones tiene este cliente. */
  buscarPorUsuario(usuarioId: number): Promise<BusquedaPorUsuarioResponse> {
    return firstValueFrom(
      this.http.get<BusquedaPorUsuarioResponse>(
        `${this.baseUrl}/by-user/${usuarioId}`,
      ),
    );
  }
}
